export default __webpack_public_path__ + "static/media/product-image-12.174b46fb.jpg";